export const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '精彩剧集', href: '#media' },
  { label: '热门话题', href: '#topics' },
  { label: '热播榜单', href: '#ranking' },
  { label: '焦点推荐', href: '#carousel' },
  { label: '常见问题', href: '#faq' },
];

export const heroData = {
  label: '全网热门剧集',
  h1: '吃瓜视频 · 热门剧集完整版高清在线播放平台',
  slogan: '追好剧，不等待 — 延禧攻略全集高清尽在吃瓜视频',
  description:
    '吃瓜视频致力于为追剧爱好者打造一站式高清观剧体验，覆盖延禧攻略、如懿传、甄嬛传、琅琊榜等海量国产经典与热门剧集。每日同步更新最新剧集资源，支持多端流畅播放，无需注册即可免费在线观看完整版。无论你是宫斗迷、古装控还是都市剧爱好者，吃瓜视频都能让你追得过瘾、看得尽兴。',
  stats: [
    { value: '1200+', label: '部高清剧集' },
    { value: '每日更新', label: '同步追剧' },
    { value: '全端适配', label: '随时随地看' },
  ],
  primaryCta: { label: '立即追剧', href: '#media' },
  secondaryCta: { label: '查看榜单', href: '#ranking' },
};

export const indexTopics = [
  {
    title: '延禧攻略专题',
    description: '魏璎珞从宫女到皇贵妃的逆袭之路，全集高清完整版',
    icon: 'ri-movie-2-line',
    href: '#media',
  },
  {
    title: '宫斗经典合集',
    description: '甄嬛传、如懿传、延禧攻略三大宫斗巅峰一网打尽',
    icon: 'ri-vip-crown-line',
    href: '#media',
  },
  {
    title: '古装权谋精选',
    description: '琅琊榜、庆余年、长安十二时辰口碑佳作合集',
    icon: 'ri-sword-line',
    href: '#media',
  },
  {
    title: '都市情感剧场',
    description: '欢乐颂、都挺好、三十而已等现实题材热剧',
    icon: 'ri-heart-line',
    href: '#media',
  },
  {
    title: '悬疑烧脑专区',
    description: '隐秘的角落、白夜追凶、沉默的真相高分悬疑剧',
    icon: 'ri-search-eye-line',
    href: '#media',
  },
  {
    title: '仙侠玄幻世界',
    description: '陈情令、香蜜沉沉烬如霜、三生三世十里桃花',
    icon: 'ri-magic-line',
    href: '#media',
  },
  {
    title: '历史正剧大赏',
    description: '大明王朝1566、大秦帝国、康熙王朝经典正剧',
    icon: 'ri-building-2-line',
    href: '#media',
  },
  {
    title: '青春校园回忆',
    description: '最好的我们、你好旧时光、致我们单纯的小美好',
    icon: 'ri-book-open-line',
    href: '#media',
  },
  {
    title: '谍战风云录',
    description: '伪装者、风筝、潜伏经典谍战剧合集',
    icon: 'ri-shield-flash-line',
    href: '#media',
  },
];

export const appData = {
  title: '吃瓜视频移动端',
  subtitle: '随时随地追好剧',
  description:
    '下载吃瓜视频 App，享受更流畅的高清播放体验。支持离线缓存、智能续播、个性化推荐，让你在地铁、公交、旅途中也能畅快追剧。延禧攻略全集已同步上线移动端。',
  features: ['高清流畅播放', '离线缓存下载', '智能断点续播', '个性化推荐'],
};

export const commentsData = [
  {
    name: '追剧小达人',
    avatar: '👩‍💻',
    time: '2小时前',
    content:
      '终于在吃瓜视频上看完了延禧攻略全集！画质真的没话说，高清完整版太爽了。魏璎珞这个角色太带感了，一口气追了二十集停不下来。推荐给所有还没看的朋友！',
    likes: 1286,
    drama: '延禧攻略',
  },
  {
    name: '古风控阿琳',
    avatar: '👩‍🎨',
    time: '5小时前',
    content:
      '吃瓜视频上的如懿传播放体验太棒了，没有广告打扰，画面清晰度也很高。周迅的演技真的封神，每一帧都是壁纸级别的质感。这个平台收录的剧集真的全！',
    likes: 967,
    drama: '如懿传',
  },
  {
    name: '深夜追剧人',
    avatar: '🧑‍💼',
    time: '8小时前',
    content:
      '对比了好几个平台，吃瓜视频的加载速度最快，而且真的不用注册就能看完整版。最近在追琅琊榜，胡歌的梅长苏太经典了。希望平台能多上一些经典老剧的高清修复版。',
    likes: 743,
    drama: '琅琊榜',
  },
  {
    name: '剧荒拯救者',
    avatar: '👩‍🏫',
    time: '1天前',
    content:
      '朋友推荐了吃瓜视频，说上面延禧攻略全集都有，抱着试试看的心态来的，结果一发不可收拾。界面清爽、分类清晰，热门剧集完整版在线看真的很方便。已经安利给全办公室了！',
    likes: 512,
    drama: '热门剧集',
  },
];

export const mediaData = [
  {
    title: '延禧攻略',
    subtitle: '宫斗 · 70集全',
    description: '乾隆六年，少女魏璎珞为寻求姐姐死亡真相，入紫禁城为宫女，凭借勇往直前的勇气和机敏灵活的头脑，一路化解重重困难，最终成为襄助乾隆盛世的令贵妃。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20imperial%20palace%20drama%20scene%20with%20a%20young%20woman%20in%20traditional%20Qing%20dynasty%20costume%20standing%20in%20ornate%20palace%20corridor%2C%20warm%20golden%20lantern%20light%2C%20deep%20red%20and%20gold%20color%20palette%2C%20cinematic%20atmosphere%2C%20soft%20shadows%2C%20period%20drama%20aesthetic%2C%20highly%20detailed%20textiles%20and%20embroidery%2C%20editorial%20photography%20style&width=800&height=450&seq=media-yanxi-01&orientation=landscape',
    tag: '热播榜 TOP1',
    tagColor: 'bg-primary-500',
    rating: '9.3',
  },
  {
    title: '琅琊榜',
    subtitle: '权谋 · 54集全',
    description: '十二年前七万赤焰军被奸人所害，少帅林殊侥幸生还，十二年后化身"麒麟才子"梅长苏重返帝都，以病弱之躯拨开重重迷雾，辅佐明君靖王，为七万赤焰忠魂洗雪污名。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20scholar%20in%20white%20robes%20standing%20by%20a%20misty%20mountain%20pavilion%2C%20ink%20wash%20painting%20aesthetic%2C%20ethereal%20fog%2C%20bamboo%20forest%20background%2C%20soft%20diffused%20lighting%2C%20elegant%20composition%2C%20classical%20Chinese%20drama%20visual%20style%2C%20serene%20atmosphere%2C%20muted%20earth%20tones&width=800&height=450&seq=media-langya-02&orientation=landscape',
    tag: '口碑神作',
    tagColor: 'bg-accent-500',
    rating: '9.4',
  },
  {
    title: '甄嬛传',
    subtitle: '宫斗 · 76集全',
    description: '少女甄嬛选秀入宫，在皇后与华妃两方势力的夹击下，从天真少女成长为善于权谋的深宫太后。孙俪封神演技，宫斗剧不可逾越的巅峰之作。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20in%20traditional%20Chinese%20imperial%20court%20dress%20with%20elaborate%20headdress%20in%20ancient%20palace%20garden%2C%20soft%20afternoon%20light%20filtering%20through%20willow%20trees%2C%20rich%20silk%20textures%2C%20classical%20Chinese%20aesthetic%2C%20warm%20golden%20tones%2C%20romantic%20atmosphere%2C%20period%20drama%20photography&width=800&height=450&seq=media-zhenhuan-03&orientation=landscape',
    tag: '宫斗经典',
    tagColor: 'bg-primary-500',
    rating: '9.2',
  },
  {
    title: '庆余年',
    subtitle: '古装 · 46集全',
    description: '身世神秘的少年范闲，自小城澹州初出茅庐，历经家族、江湖、庙堂的种种考验。张若昀主演，融合权谋、武侠与轻喜剧元素的现象级爆款。',
    image: 'https://readdy.ai/api/search-image?query=Young%20man%20in%20traditional%20Chinese%20martial%20arts%20costume%20standing%20on%20ancient%20city%20wall%20overlooking%20bustling%20market%2C%20dramatic%20clouds%20in%20sky%2C%20warm%20sunset%20lighting%2C%20epic%20cinematic%20scale%2C%20historical%20fantasy%20aesthetic%2C%20rich%20atmospheric%20depth&width=800&height=450&seq=media-qingyu-04&orientation=landscape',
    tag: '现象级爆款',
    tagColor: 'bg-accent-500',
    rating: '9.1',
  },
  {
    title: '如懿传',
    subtitle: '宫斗 · 87集全',
    description: '乌拉那拉·如懿与乾隆皇帝从青梅竹马到帝王夫妻，在深宫岁月中经历信任、猜忌、决裂。周迅、霍建华主演，精良制作还原清宫历史质感。',
    image: 'https://readdy.ai/api/search-image?query=Middle-aged%20Chinese%20empress%20in%20magnificent%20Qing%20dynasty%20ceremonial%20robes%20in%20grand%20palace%20hall%2C%20dramatic%20chiaroscuro%20lighting%2C%20ornate%20gold%20throne%20background%2C%20deep%20rich%20colors%2C%20solemn%20atmosphere%2C%20historical%20drama%20cinematography%2C%20painterly%20composition&width=800&height=450&seq=media-ruyi-05&orientation=landscape',
    tag: '制作精良',
    tagColor: 'bg-primary-500',
    rating: '8.9',
  },
];

export const carouselData = [
  {
    title: '延禧攻略：一个宫女的逆袭传奇',
    category: '焦点专题',
    description: '从绣坊宫女到皇贵妃，魏璎珞用智慧与勇气书写了一段传奇。深度解析角色成长线、服化道美学与历史背景，带你重温这部现象级清宫剧的魅力所在。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20palace%20drama%20cinematic%20scene%20with%20a%20determined%20young%20woman%20in%20traditional%20Qing%20dynasty%20attire%20walking%20through%20the%20Forbidden%20City%20courtyard%2C%20dramatic%20lighting%2C%20rich%20red%20and%20gold%20imperial%20colors%2C%20epic%20cinematic%20scale%2C%20high%20contrast%20shadows%2C%20majestic%20palace%20architecture%20framing%20the%20scene&width=1200&height=600&seq=carousel-yanxi-01&orientation=landscape',
    highlight: '现象级宫斗大剧',
  },
  {
    title: '古装权谋剧的巅峰艺术：琅琊榜',
    category: '经典回顾',
    description: '一部剧改变了一个类型的标杆。琅琊榜以精妙的叙事结构、深邃的人物塑造和水墨画般的美学风格，定义了国产古装剧的新高度。胡歌的梅长苏为何成为不可超越的经典？',
    image: 'https://readdy.ai/api/search-image?query=Solitary%20figure%20in%20traditional%20white%20Chinese%20robes%20standing%20at%20the%20edge%20of%20a%20misty%20cliff%20overlooking%20ancient%20mountain%20landscape%2C%20ink%20wash%20painting%20aesthetic%2C%20ethereal%20atmosphere%2C%20soft%20monochrome%20tones%20with%20subtle%20green%20accents%2C%20philosophical%20mood&width=1200&height=600&seq=carousel-langya-02&orientation=landscape',
    highlight: '豆瓣9.4分神作',
  },
  {
    title: '甄嬛传：深宫女性的权力游戏',
    category: '深度解读',
    description: '76集的篇幅，铺陈了一个少女如何在权力旋涡中步步为营。甄嬛传不仅是宫斗的极致，更是对人性与命运的深刻拷问。十余年过去，为何它依然无人能超越？',
    image: 'https://readdy.ai/api/search-image?query=Regal%20Chinese%20empress%20seated%20in%20ornate%20palace%20throne%20room%2C%20surrounded%20by%20flowing%20silk%20curtains%20and%20gilded%20decorations%2C%20dramatic%20shaft%20of%20light%20from%20above%2C%20deep%20crimson%20and%20gold%20color%20scheme%2C%20powerful%20atmosphere%2C%20cinematic%20portrait%20lighting&width=1200&height=600&seq=carousel-zhenhuan-03&orientation=landscape',
    highlight: '宫斗剧天花板',
  },
  {
    title: '庆余年：古装剧的破圈新范式',
    category: '新锐解读',
    description: '穿越设定遇上权谋大戏，幽默与严肃的完美平衡。庆余年以独特的叙事视角和精良的制作，打破了古装剧的固有模式。第二季回归后热度持续飙升，展现了IP改编的更多可能。',
    image: 'https://readdy.ai/api/search-image?query=Young%20man%20in%20dark%20traditional%20Chinese%20attire%20holding%20a%20sword%20in%20ancient%20courtyard%20with%20falling%20cherry%20blossoms%2C%20dynamic%20composition%2C%20warm%20sunset%20backlighting%2C%20martial%20arts%20film%20aesthetic%2C%20rich%20atmospheric%20depth%2C%20heroic%20yet%20poetic%20mood&width=1200&height=600&seq=carousel-qingyu-04&orientation=landscape',
    highlight: '第二季热播中',
  },
];

export const faqData = [
  {
    q: '吃瓜视频是否需要注册才能观看？',
    a: '不需要注册。吃瓜视频上的所有剧集均支持免注册免费在线观看，打开网站即可直接播放延禧攻略全集等热门剧集完整版，无需登录或付费。',
  },
  {
    q: '延禧攻略全集在哪里可以高清观看？',
    a: '延禧攻略全集（共70集）已在吃瓜视频完整上线，支持高清画质播放。您可以通过首页"精彩剧集"板块直接进入观看，画质清晰流畅。',
  },
  {
    q: '吃瓜视频支持哪些设备观看？',
    a: '吃瓜视频全面适配桌面电脑、平板和手机端，无论您在办公室、家中还是通勤路上，都能流畅观看热门剧集完整版。移动端体验同样出色。',
  },
  {
    q: '剧集更新速度快吗？',
    a: '吃瓜视频保持每日同步更新节奏，热门在播剧集上线后第一时间更新。延禧攻略等已完结经典剧集全集已完整收录，追剧不必等待。',
  },
  {
    q: '播放过程中会有广告吗？',
    a: '吃瓜视频致力于提供纯净的观剧体验，播放过程中无贴片广告干扰，让您沉浸式享受高清完整版剧集内容。',
  },
  {
    q: '如何找到自己想看的剧集？',
    a: '您可以通过首页的分类专题、搜索功能或热播榜单快速找到感兴趣的剧集。我们还提供个性化推荐，帮助您发现更多精彩内容。',
  },
];

export const aboutData = {
  title: '关于吃瓜视频',
  paragraphs: [
    '吃瓜视频是一个专注于热门剧集高清在线播放的综合视频平台，致力于为全国追剧爱好者提供一站式观剧服务。我们收录了包括延禧攻略、甄嬛传、琅琊榜、如懿传、庆余年等在内的上千部国产经典与热门剧集完整版资源，覆盖宫斗、权谋、都市、悬疑、仙侠等多元题材。',
    '平台坚持"免注册、免付费、无广告"的服务理念，所有剧集均支持高清画质播放，全面适配桌面端与移动端。吃瓜视频以每日同步更新的节奏，确保追剧用户不错过任何精彩内容。无论你是资深剧迷还是休闲观众，吃瓜视频都能成为你最贴心的追剧伙伴。',
  ],
};

export const rankingData = [
  { rank: 1, title: '延禧攻略', category: '宫斗', hot: '本周播放量 328万', isTop: true },
  { rank: 2, title: '庆余年 第二季', category: '古装权谋', hot: '本周播放量 295万', isTop: true },
  { rank: 3, title: '甄嬛传', category: '宫斗', hot: '本周播放量 267万', isTop: true },
  { rank: 4, title: '琅琊榜', category: '权谋', hot: '本周播放量 241万', isTop: false },
  { rank: 5, title: '如懿传', category: '宫斗', hot: '本周播放量 218万', isTop: false },
  { rank: 6, title: '陈情令', category: '仙侠', hot: '本周播放量 196万', isTop: false },
  { rank: 7, title: '长安十二时辰', category: '古装悬疑', hot: '本周播放量 174万', isTop: false },
];

export const cardsData = [
  {
    title: '宫斗剧入门指南：从甄嬛传到延禧攻略',
    description: '三分钟带你了解宫斗剧的魅力所在，从经典到新锐，吃瓜视频为你精选必看片单。',
    image: 'https://readdy.ai/api/search-image?query=Three%20elegant%20Chinese%20women%20in%20traditional%20Qing%20dynasty%20court%20costumes%20standing%20in%20beautiful%20palace%20garden%20with%20blooming%20peony%20flowers%2C%20soft%20natural%20light%2C%20rich%20silk%20textures%2C%20harmonious%20color%20palette%2C%20classical%20Chinese%20aesthetic%20photography&width=600&height=400&seq=card-gongdou-01&orientation=landscape',
    tag: '入门指南',
  },
  {
    title: '权谋剧巅峰之作盘点：琅琊榜领衔',
    description: '国产权谋剧何以封神？从琅琊榜到大明王朝，吃瓜视频为你深度解析。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20study%20room%20with%20scrolls%20and%20ink%20brushes%20on%20wooden%20desk%2C%20soft%20candlelight%2C%20traditional%20scholarly%20atmosphere%2C%20warm%20amber%20tones%2C%20contemplative%20mood%2C%20still%20life%20photography%20style%20with%20historical%20artifacts&width=600&height=400&seq=card-quanmou-02&orientation=landscape',
    tag: '深度解析',
  },
  {
    title: '仙侠剧为何让人欲罢不能？',
    description: '从陈情令到香蜜，仙侠世界的奇幻魅力与情感共鸣，吃瓜视频带你一探究竟。',
    image: 'https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20fantasy%20landscape%20with%20floating%20mountains%20and%20waterfalls%2C%20two%20figures%20in%20flowing%20white%20and%20blue%20traditional%20robes%2C%20magical%20glowing%20particles%2C%20dreamy%20atmosphere%2C%20soft%20pastel%20color%20scheme%2C%20celestial%20aesthetic&width=600&height=400&seq=card-xianxia-03&orientation=landscape',
    tag: '类型解读',
  },
  {
    title: '2024年最值得期待的国产剧',
    description: '吃瓜视频为你整理了年度最受期待的剧集清单，追剧日历已为你备好。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20film%20set%20with%20director%20chair%20and%20professional%20camera%20equipment%2C%20warm%20studio%20lighting%2C%20creative%20atmosphere%2C%20behind%20the%20scenes%20vibe%2C%20cinematic%20production%20environment%2C%20rich%20textures%20and%20depth&width=600&height=400&seq=card-expected-04&orientation=landscape',
    tag: '追剧日历',
  },
  {
    title: '悬疑剧迷必看：国产高分悬疑片单',
    description: '隐秘的角落、白夜追凶、沉默的真相……吃瓜视频悬疑专区已为你整理好。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20dark%20alley%20at%20night%20with%20a%20single%20warm%20streetlight%2C%20wet%20cobblestone%20reflecting%20light%2C%20atmospheric%20fog%2C%20noir%20film%20aesthetic%2C%20Chinese%20urban%20setting%2C%20deep%20shadows%20and%20high%20contrast%2C%20suspenseful%20mood&width=600&height=400&seq=card-xuanyi-05&orientation=landscape',
    tag: '悬疑片单',
  },
];

export const updatesData = [
  {
    date: '2024年7月30日',
    content: '延禧攻略全集高清修复版已上线，画质全面升级，欢迎重温经典。',
  },
  {
    date: '2024年7月28日',
    content: '庆余年第二季最新剧集已同步更新至第28集，追剧党速来。',
  },
  {
    date: '2024年7月25日',
    content: '吃瓜视频移动端版本更新至v3.6.0，优化播放流畅度和界面交互。',
  },
  {
    date: '2024年7月22日',
    content: '新增宫斗经典专题合集，甄嬛传、如懿传、延禧攻略一网打尽。',
  },
  {
    date: '2024年7月18日',
    content: '琅琊榜4K修复版独家上线，胡歌经典角色梅长苏高清再现。',
  },
  {
    date: '2024年7月15日',
    content: '热门剧集完整版在线看功能全面升级，加载速度提升40%。',
  },
  {
    date: '2024年7月10日',
    content: '吃瓜视频日活跃用户突破百万，感谢每一位追剧伙伴的支持。',
  },
  {
    date: '2024年7月5日',
    content: '悬疑剧专场上线，隐秘的角落、白夜追凶等高分剧集高清收录。',
  },
];

export const contactData = {
  title: '联系我们',
  description:
    '如果您有剧集推荐、内容建议或合作意向，欢迎通过以下方式与吃瓜视频团队取得联系。我们珍视每一位观众的反馈。',
  email: 'contact@chiguavideo.com',
  wechat: '吃瓜视频官方',
  weibo: '@吃瓜视频',
};

export const topicsData = [
  { name: '延禧攻略全集', heat: '328万讨论', href: '#media' },
  { name: '魏璎珞名场面', heat: '215万讨论', href: '#media' },
  { name: '庆余年第二季', heat: '198万讨论', href: '#media' },
  { name: '宫斗剧推荐', heat: '176万讨论', href: '#index' },
  { name: '琅琊榜经典台词', heat: '154万讨论', href: '#media' },
  { name: '甄嬛传细节', heat: '142万讨论', href: '#media' },
  { name: '古装剧服化道', heat: '128万讨论', href: '#carousel' },
  { name: '国产剧高分榜', heat: '115万讨论', href: '#ranking' },
  { name: '如懿传名场面', heat: '103万讨论', href: '#media' },
  { name: '吃瓜视频高清', heat: '97万讨论', href: '#hero' },
];

export const featuresData = [
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    description: '全站剧集支持1080P高清播放，经典剧集提供4K修复版，带来沉浸式观剧体验。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '免注册观看',
    description: '无需注册登录，无需付费订阅，打开即看，所有热门剧集完整版触手可及。',
  },
  {
    icon: 'ri-device-line',
    title: '全端适配',
    description: '桌面、平板、手机三端完美适配，断点续播功能让你随时随地无缝追剧。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '每日同步更新',
    description: '热门在播剧集每日同步更新，追剧不等待，第一时间看最新剧情。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '纯净观剧',
    description: '播放全程无贴片广告干扰，专注内容本身，给你最纯粹的追剧时光。',
  },
];